import { render, staticRenderFns } from "./gispersonal.vue?vue&type=template&id=8f476b44&scoped=true"
import script from "./gispersonal.vue?vue&type=script&lang=js"
export * from "./gispersonal.vue?vue&type=script&lang=js"
import style0 from "./gispersonal.vue?vue&type=style&index=0&id=8f476b44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f476b44",
  null
  
)

export default component.exports